import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { Login } from './pages/Auth/Login';
import { Dashboard } from './pages/Dashboard';
import { Devices } from './pages/Devices';
import { ErrorsAndCrashes } from './pages/ErrorsAndCrashes';
import { Logs } from './pages/Logs';
import { Admin } from './pages/Admin';
import { Plans } from './pages/Plans';
import { Finances } from './pages/Finances';
import { Cobrancas } from './pages/Cobrancas';
import { Support } from './pages/Support';
import { Uptime } from './pages/Uptime';
import { Team } from './pages/Team';
import { Contratacoes } from './pages/Contratacoes';
import { Orcamentos } from './pages/Orcamentos';
import { Notificacoes } from './pages/Notificacoes';
import { ChangePassword } from './pages/ChangePassword';
import { Settings } from './pages/Settings';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/trocar-senha"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/"
              element={
                <ProtectedRoute permission="dashboard">
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/devices"
              element={
                <ProtectedRoute permission="devices">
                  <Devices />
                </ProtectedRoute>
              }
            />
            <Route
              path="/errors"
              element={
                <ProtectedRoute permission="errors">
                  <ErrorsAndCrashes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/logs"
              element={
                <ProtectedRoute permission="logs">
                  <Logs />
                </ProtectedRoute>
              }
            />
            <Route
              path="/uptime"
              element={
                <ProtectedRoute permission="uptime">
                  <Uptime />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute permission="users">
                  <Admin />
                </ProtectedRoute>
              }
            />
            <Route
              path="/plans"
              element={
                <ProtectedRoute permission="plans">
                  <Plans />
                </ProtectedRoute>
              }
            />
            <Route
              path="/financas"
              element={
                <ProtectedRoute permission="finance">
                  <Finances />
                </ProtectedRoute>
              }
            />
            <Route
              path="/cobrancas"
              element={
                <ProtectedRoute permission="finance">
                  <Cobrancas />
                </ProtectedRoute>
              }
            />
            <Route
              path="/suporte"
              element={
                <ProtectedRoute permission="support">
                  <Support />
                </ProtectedRoute>
              }
            />
            <Route
              path="/equipe"
              element={
                <ProtectedRoute permission="team">
                  <Team />
                </ProtectedRoute>
              }
            />
            <Route
              path="/contratacoes"
              element={
                <ProtectedRoute permission="careers">
                  <Contratacoes />
                </ProtectedRoute>
              }
            />
            <Route
              path="/orcamentos"
              element={
                <ProtectedRoute permission="orcamentos">
                  <Orcamentos />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notificacoes"
              element={
                <ProtectedRoute permission="notifications">
                  <Notificacoes />
                </ProtectedRoute>
              }
            />
            {/* Assinaturas foi unificada na página de Usuários (/admin). */}
            <Route path="/subscriptions" element={<Navigate to="/admin" replace />} />
            <Route
              path="/settings"
              element={
                <ProtectedRoute permission="settings">
                  <Settings />
                </ProtectedRoute>
              }
            />
          </Routes>
        </NotificationProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
